import { render, staticRenderFns } from "./VContentEditablePara.vue?vue&type=template&id=2ba31aae&scoped=true&"
import script from "./VContentEditablePara.vue?vue&type=script&lang=js&"
export * from "./VContentEditablePara.vue?vue&type=script&lang=js&"
import style0 from "./VContentEditablePara.vue?vue&type=style&index=0&id=2ba31aae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba31aae",
  null
  
)

export default component.exports